import mon_pp from "../img/mon_pp.png";
import all4basket from "../img/all4basket.jpeg";
import nuit_info from "../img/nuit_info.png";
import jeu_textuel from "../img/jeu_textuel.png";
import nuit_info_2025 from "../img/nuit_info_2025.png";
import cdwebstudios from "../img/cdwebstudios_logo.png";

const projects = [
  {
    img: cdwebstudios,
    title: "CD Web Studios",
    techno: "HTML · CSS · JS",
    summary: "Création d'une entreprise en freelance de développement et création de sites internet pour petites entreprises et indépendants, maintenance de sites web, intégration de solutions e-commerce.",
    description: "Création d'une entreprise en freelance de développement et création de sites internet pour petites entreprises et indépendants, maintenance de sites web, intégration de solutions e-commerce.",
    technos: "React · NodeJS · HTML5 · CSS3 · JavaScript · MongoDB",
    competences: "Applications web · Développement front-end · JavaScript · Développement back-end",
    site: "https://cdwebstudios.fr/"
  },
  {
    img: nuit_info_2025,
    title: "Nuit de l'info 2025",
    techno: "HTML · CSS · JS · MongoDB",
    summary: "Participation à la Nuit de l'info 2025, une compétition nationale réunissant des étudiants autour du développement d'une application web.",
    description: "Participation à la Nuit de l'info le 4 décembre 2025, une compétition nationale qui réunit les étudiants pour travailler ensemble sur le développement d'une application web.",
    technos: "HTML5 · CSS3 · JavaScript (front) · Gestion de la logique côté client · Gestion de base de données avec MongoDB",
    competences: "Applications web · Développement front-end · JavaScript · Développement back-end",
    github: "https://github.com/Pierre-Deldalle/Nuit-de-l-info-2025",
    site: "https://nuit-info-2025.netlify.app/"
  },
  {
    img: mon_pp,
    title: "Mon Programme Perso",
    techno: "HTML · CSS · JS",
    summary: "Application web pour gérer des tâches dans un calendrier avec catégories et accès rapide à la prochaine tâche.",
    description: "Dans le cadre de mon autoformation en développement web fullstack, j'ai créé une application permettant d'ajouter des tâches dans un calendrier, d'associer chaque tâche à une catégorie et d'accéder rapidement à la prochaine tâche correspondant à la catégorie sélectionnée.",
    technos: "HTML5 · CSS3 · JavaScript (front) · Gestion de la logique côté client",
    competences: "Applications web · Développement front-end · JavaScript",
    github: "https://github.com/ClemTeuf/Mon-Programme-Perso",
    site: "https://monprogrammeperso.netlify.app/"
  },
  {
    img: all4basket,
    title: "All4Basket",
    techno: "HTML · CSS · JS",
    summary: "Application web sur le basket aux Jeux Olympiques de 2024, réalisée en équipe à l'IUT de Calais.",
    description: "Dans le cadre d'une situation d'apprentissage et d'évaluation au sein de l'IUT de Calais, j'ai créé une application web sur le basket aux Jeux Olympiques de 2024.",
    technos: "HTML5 · CSS3 · JavaScript (front) · Gestion de la logique côté client",
    competences: "Applications web · Programmation · Feuilles de style en cascade (CSS) · HTML · HTML5",
    github: "https://github.com/ClemTeuf/All4Basket",
    site: "https://projets.jrcan.dev/all4basket-paris2024/"
  },
  {
    img: nuit_info,
    title: "Nuit de l'info 2024",
    techno: "HTML · CSS · JS",
    summary: "Participation à la Nuit de l'info 2024, une compétition nationale de développement d'application web.",
    description: "Participation à la Nuit de l'info le 5 décembre 2024, une compétition nationale qui réunit les étudiants pour travailler ensemble sur le développement d'une application web.",
    technos: "HTML5 · CSS3 · JavaScript (front) · Gestion de la logique côté client",
    competences: "Applications web · Programmation · JavaScript · CSS",
    github: "https://github.com/ClemTeuf/Nuit_de_l_info_2024",
    site: "https://les-moins-2-dix-nuit-info.netlify.app/"
  },
  {
    img: jeu_textuel,
    title: "Jeu textuel",
    techno: "C",
    summary: "Jeu textuel créé en binôme dans le cadre d'une situation d'apprentissage et d'évaluation.",
    description: "Dans le cadre d'une situation d'apprentissage et d'évaluation, j'ai créé avec un collègue un jeu textuel en langage C.",
    technos: "C (console) · Gestion de la logique côté client",
    competences: "Programmation · Logique algorithmique · Travail en binôme",
    github: "https://github.com/ClemTeuf/Jeu_textuel"
  }
];

export default projects;
